import { setImage } from './setImage';

interface Manufacturer {
  manufacturerName?: string;
  manufacturerLogo?: string;
}

export function setManufacturer(manufacturer?: Manufacturer) {
  if (
    manufacturer &&
    (manufacturer.manufacturerName || manufacturer.manufacturerLogo)
  ) {
    return {
      '@type': 'Organization',
      logo: setImage(manufacturer.manufacturerLogo),
      name: manufacturer.manufacturerName,
    };
  }
  return undefined;
}
